const routes = [{
        path: '/',
        redirect:"/admin/login"
      
    },
   
    { path: '*', beforeEnter: (to, from, next) => { next('/404') } },

]



export default routes
